if (!customElements.get('emily-before-after')) {
  customElements.define(
    'emily-before-after',
    class EmilyBeforeAfter extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.em-before__range');
        if (!this.range || this.initialized) return;

        this.initialized = true;
        this.updatePosition = () => {
          this.style.setProperty('--em-compare-position', `${this.range.value}%`);
        };

        this.range.addEventListener('input', this.updatePosition);
        this.range.addEventListener('change', this.updatePosition);
        this.updatePosition();
      }

      disconnectedCallback() {
        if (!this.range || !this.updatePosition) return;
        this.range.removeEventListener('input', this.updatePosition);
        this.range.removeEventListener('change', this.updatePosition);
      }
    }
  );
}
